// الجهاز يقول أين هو لـ«أجهزتي» (قرار المالك 06/10/2026: «محتاج ازود اللوكيشن واسم المدينة… اعمل كل حاجه ادق وافضل»).
//
// مرّةً واحدة في تحميل الصفحة، وفقط حين يطلبها الخادم (`me.needsLocation`: لم يُرسل هذا الجهاز موقعه خلال 6 ساعات، وملف
// المدن موجود على الخادم). الموقع بنفس طريق البصمة (`tapLocation`): GPS التطبيق مع كشف التزوير، أو موقع المتصفّح بإذن صاحبه.
// ورفضُ الإذن أو تعذّرُه لا يفعل شيئًا — «أجهزتي» تبقى بالمدينة التقريبية من عنوان الإنترنت. والخادم لا يحفظ الإحداثيات بل
// اسم المكان الأقرب وحده.
import { useEffect, useRef } from 'react';
import { post, type Me } from '../lib/api.ts';
import { tapLocation } from '../attendance/geo.ts';

export function useReportDeviceLocation(me: Me | null): void {
  const sent = useRef(false);
  useEffect(() => {
    if (!me || me.mustChangePassword || me.needsLocation !== true || sent.current) return;
    sent.current = true;
    void (async () => {
      try {
        const b = await tapLocation();
        if (b.locationMissing || b.gpsLat == null || b.gpsLon == null) return;
        await post('/me/sessions/location', {
          lat: b.gpsLat, lon: b.gpsLon,
          ...(b.gpsAccuracyM != null ? { accuracyM: b.gpsAccuracyM } : {}),
          ...(b.mockLocation === true ? { mock: true } : {}),
        });
      } catch { /* المكان مساعدٌ لا شرط — لا رسالة على الشاشة */ }
    })();
  }, [me]);
}
